<script lang="ts">import { goto } from "$app/navigation";
import { Button } from "@infinitro/button";
import { cfgBrand, cfgBrandTitle, cfgSupportEmail } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { isMobile, loggedIn, toSiteUrl } from "@infinitro/global";
const BRAND_TITLE = cfgBrandTitle().toUpperCase();
const BRAND = cfgBrand();
const supportEmail = cfgSupportEmail();
const supportEmailStyles = "color: var(--color-primary-500);";
</script>

<!-- Full-page restriction state shown when user's country blocks sports access -->
<div class="sports-unavailable">
	<div class="content">
		<p class="main-text">
			{@html $t(Verbiage.sorry_text, 'global', { BRAND: BRAND_TITLE })}
		</p>
		<p class="subtext">
			{#if $isMobile}
				{@html $t(Verbiage.gaming_license_norms_text_mobile, 'global', {
					BRAND: BRAND,
					SUPPORT_EMAIL: supportEmail,
					SUPPORT_EMAIL_STYLES: supportEmailStyles
				})}
			{:else}
				{@html $t(Verbiage.gaming_license_norms_text, 'global', {
					BRAND: BRAND,
					SUPPORT_EMAIL: supportEmail,
					SUPPORT_EMAIL_STYLES: supportEmailStyles
				})}
			{/if}
		</p>
		<Button
			text={$t(Verbiage.go_to_slots)}
			variant="primary"
			onClick={() => goto(toSiteUrl('/', $loggedIn))}
		/>
	</div>
</div>

<style>
	.sports-unavailable {
		display: flex;
		width: 100%;
		align-items: center;
		justify-content: center;
		min-height: calc(100dvh - 72px)
}

	.content {
		display: flex;
		max-width: 540px;
		flex-direction: column;
		align-items: center
}

	.content > :not([hidden]) ~ :not([hidden]) {
		--tw-space-y-reverse: 0;
		margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
		margin-bottom: calc(1rem * var(--tw-space-y-reverse))
}

	.content {
		padding-left: 1.5rem;
		padding-right: 1.5rem;
		text-align: center
}

	.main-text {
		font-size: 1.25rem;
		line-height: 1.75rem;
		font-weight: 700;
		color: var(--color-text-100)
}

	.subtext {
		padding-bottom: 0.5rem;
		font-size: 0.875rem;
		line-height: 1.25rem;
		--tw-text-opacity: 1;
		color: rgb(156 163 175 / var(--tw-text-opacity, 1))
}

	:global(.subtext a) {
		text-decoration-line: none;
		color: var(--color-primary-500)
}
</style>
